import React from "react";
import { ExternalLink, Lock } from "lucide-react";
import { Link } from "react-router-dom";

const MAIN_SITE = "https://viewluxwindows.com/";

export default function UtilityBar() {
  return (
    <div
      data-testid="utility-bar"
      className="fixed top-0 inset-x-0 z-[60] hidden md:block bg-[#0a1a17] text-[#e2b880] border-b border-[#c99658]/15"
    >
      <div className="container-vlx h-8 flex items-center justify-between text-[10.5px] tracking-[0.4em] uppercase font-raleway">
        <span className="opacity-80">
          ViewLux Colorado · Serving the Rocky Mountain Region
        </span>
        <div className="flex items-center gap-6">
          <Link
            data-testid="utility-dealer-portal"
            to="/admin"
            className="inline-flex items-center gap-2 hover:text-white transition-colors"
          >
            <Lock className="w-3 h-3" />
            Dealer Portal
          </Link>
          <a
            data-testid="utility-main-site"
            href={MAIN_SITE}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 hover:text-white transition-colors"
          >
            More information at viewluxwindows.com
            <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </div>
    </div>
  );
}
